import { SvsSaleApi } from '@play-co/svs-navbar';
import { MockStorageService } from '../mock/MockStorageService';

const saleMap = {
  characterPass: {
    mintStartDate: '2022-11-10T21:20:31.931Z',
    mintEndDate: '2023-12-01T21:20:31.000Z',
    plotPrice: '0.001',
    eligiblePlots: 2,
    remainingSupply: 300,
  },
};

export class MockSaleService implements SvsSaleApi {

  constructor(
    private mockService: MockStorageService,
  ) {
  }
  
  async fetchSaleIsActive(opts: { tokenType: string; }): Promise<boolean> {
    const sale = saleMap[opts.tokenType];
    if (!sale) {
      return false;
    }

    const startTime = new Date(sale.mintStartDate).getTime();
    const endTime = new Date(sale.mintEndDate).getTime();
    const nowTime = new Date().getTime();
    return nowTime >= startTime && nowTime < endTime;
  }
  async fetchMintDate(opts: { tokenType: string; }): Promise<string> {
    const sale = saleMap[opts.tokenType];
    if (!sale) {
      return null;
    }

    return sale.mintStartDate;
  }
  fetchMintEndDate(opts: { tokenType: string; }): Promise<string> {
    const sale = saleMap[opts.tokenType];
    if (!sale) {
      return null;
    }

    return sale.mintEndDate;
  }
  fetchPlotPrice(opts: { tokenType: string; }): Promise<string> {
    const sale = saleMap[opts.tokenType];
    if (!sale) {
      return null;
    }

    return sale.protPrice;
  }
  fetchEligiblePlots(opts: { walletAddress?: string; } & { tokenType: string; }): Promise<number> {
    const sale = saleMap[opts.tokenType];
    if (!sale) {
      return null;
    }

    return sale.eligiblePlots;
  }
  fetchRemainingSupply(opts: { tokenType: string; }): Promise<number> {
    const sale = saleMap[opts.tokenType];
    if (!sale) {
      return null;
    }

    return sale.remainingSupply;
  }
  mint(opts: { amount: number; } & { tokenType: string; }): Promise<any[]> {
    throw new Error('Method not implemented.');
  }
}
